module.exports = __webpack_public_path__ + "static/media/food-app-2.1579905a.jpg";